<script setup>
import { DirectionsBlockLayout } from '~~/types/enums'
import { headingText } from '~/composables/headingText'

const { model } = defineProps(['model'])

const startNumber = computed(() => (model?.startNumber?.value ?? 1) - 1)
</script>

<template>
  <div
    v-if="model"
    class="directions-block block-spacing"
    :class="{
      'directions-block--split': model?.layout?.value === DirectionsBlockLayout.Wide,
    }"
    :style="{
      '--start-number': startNumber,
    }"
  >
    <div class="container-fluid">
      <div class="directions-block__content-wrap prose">
        <BlockHeader
          :title="model?.title?.value || ''"
          :summary="model?.body?.value || ''"
        />

        <div
          v-if="model?.items?.expandedValue"
          class="directions-block__list-wrap"
        >
          <ol class="directions-block__list">
            <li
              v-for="item in model?.items?.expandedValue"
              :key="item.id"
            >
              <h3
                v-if="headingText(item.title)"
                class="h5 mt-0"
              >
                {{ headingText(item.title) }}
              </h3>
              <div v-html="item.body?.value || ''" />
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/directions-block.scss';
</style>
